
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import ServiceList from './List';
import ServiceAdd from './Add';
import ServiceDetail from './Detail';


export default class ServiceRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/service" exact component={ServiceList} />
        <Route path="/service/add" exact component={ServiceAdd} />
        <Route path="/service/:id" component={ServiceDetail} />
      </Switch>
    );
  }
}
